import { FloatingMenu } from "./FloatingMenu.js";
import DrawerMenu_module_default from "./DrawerMenu.module.js";
import { MenuContext } from "./MenuContext.js";
import { getPlatform } from "../../utils/platform.js";
import { DrawerMenu } from "./DrawerMenu.js";
import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Content, ContextMenuItem, ContextMenuPortal, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger, Portal, Root, Trigger } from "@radix-ui/react-context-menu";
import { Drawer } from "vaul";
//#region src/components/Menu/ContextMenu.tsx
var ContextMenuItemWrapper = ({ onSelect, children }) => /* @__PURE__ */ jsx(ContextMenuItem, {
	onSelect: onSelect ?? void 0,
	asChild: true,
	children
});
var ContextSubMenuWrapper = ({ trigger, children, open, onOpenChange }) => /* @__PURE__ */ jsxs(ContextMenuSub, {
	open,
	onOpenChange,
	children: [/* @__PURE__ */ jsx(ContextMenuSubTrigger, {
		asChild: true,
		children: trigger
	}), /* @__PURE__ */ jsx(ContextMenuPortal, { children: /* @__PURE__ */ jsx(ContextMenuSubContent, {
		asChild: true,
		alignOffset: -20,
		children: /* @__PURE__ */ jsx(FloatingMenu, {
			title: "",
			showTitle: false,
			children
		})
	}) })]
});
/**
* A menu opened by right-clicking or long-pressing another UI element.
*/
var ContextMenu = ({ title, showTitle = true, onOpenChange: onOpenChangeProp, trigger: triggerProp, hasAccessibleAlternative, children: childrenProp }) => {
	const [open, setOpen] = useState(false);
	const onOpenChange = useCallback((value) => {
		setOpen(value);
		onOpenChangeProp?.(value);
	}, [setOpen, onOpenChangeProp]);
	const platform = getPlatform();
	const drawer = platform === "android" || platform === "ios";
	const context = useMemo(() => ({
		MenuItemWrapper: drawer ? null : ContextMenuItemWrapper,
		SubMenuWrapper: drawer ? null : ContextSubMenuWrapper,
		onOpenChange
	}), [onOpenChange]);
	const children = /* @__PURE__ */ jsx(MenuContext.Provider, {
		value: context,
		children: childrenProp
	});
	const trigger = /* @__PURE__ */ jsx(Trigger, {
		"aria-haspopup": "menu",
		tabIndex: hasAccessibleAlternative ? void 0 : 0,
		asChild: true,
		children: triggerProp
	});
	return drawer ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Root, {
		onOpenChange,
		children: trigger
	}), /* @__PURE__ */ jsx(Drawer.Root, {
		open,
		onOpenChange,
		children: /* @__PURE__ */ jsxs(Drawer.Portal, { children: [/* @__PURE__ */ jsx(Drawer.Overlay, { className: classNames(DrawerMenu_module_default.bg) }), /* @__PURE__ */ jsx(Drawer.Content, {
			asChild: true,
			children: /* @__PURE__ */ jsx(DrawerMenu, {
				title,
				children
			})
		})] })
	})] }) : /* @__PURE__ */ jsxs(Root, {
		onOpenChange,
		children: [trigger, /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Content, {
			asChild: true,
			children: /* @__PURE__ */ jsx(FloatingMenu, {
				showTitle,
				title,
				children
			})
		}) })]
	});
};
//#endregion
export { ContextMenu };

//# sourceMappingURL=ContextMenu.js.map